module.exports = __webpack_public_path__ + "static/media/no_image.84251c7a.png";